import React from 'react'
import styled, { keyframes, css } from 'styled-components'

export default function AnimatedCheckMark({ loadComplete }) {
  return (
    <CircleLoader loadComplete={loadComplete}>
      <CheckMark className="draw" loadComplete={loadComplete} />
    </CircleLoader>
  )
}

const loaderSpin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`
const checkmark = keyframes`
  0% {
    height: 0;
    width: 0;
    opacity: 1;
  }
  20% {
    height: 0;
    width: 1.75em;
    opacity: 1;
  }
  40% {
    height: 3.5em;
    width: 1.75em;
    opacity: 1;
  }
  100% {
    height: 3.5em;
    width: 1.75em;
    opacity: 1;
  }
`

const CircleLoader = styled.div`
  margin: 3.5em 0;
  border: 3px solid rgba(0, 0, 0, 0.2);
  border-left-color: #5cb85c;
  animation: ${loaderSpin} 1.2s infinite linear;
  position: relative;
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  width: 7em;
  height: 7em;
  transition: none;
  ${(props) =>
    props.loadComplete &&
    css`
      -webkit-animation: none;
      animation: none;
      border: 3px solid #21ba45 !important;
      transition: border 500ms ease-out;
      margin: 3.5em 0 1.5em 0;
    `}
`

const CheckMark = styled.div`
  display: ${(props) => (props.loadComplete ? 'block' : `none`)};

  &.draw:after {
    animation-duration: 800ms;
    animation-timing-function: ease;
    animation-name: ${checkmark};
    transform: scaleX(-1) rotate(135deg);
  }

  &:after {
    opacity: 1;
    height: 3.5em;
    width: 1.75em;
    transform-origin: left top;
    border-right: 4px solid #21ba45;
    border-top: 4px solid #21ba45;
    content: '';
    left: 1.75em;
    top: 3.5em;
    position: absolute;
  }
`
